import React from "react";

import Hero from "../../commons/Hero";
import Flex from "../../commons/Flex";
import Image from "../../commons/Image";
import Page from "../../commons/Page";
import SignupBlock from "../../blocks/SignupBlock";
import Pagination from "../../commons/Pagination";

export default function BasePage({
  title,
  subtitle,
  page,
  pathname,
  children,
  itemCount,
  pageSize,
  currentPage,
  ...otherProps
}) {
  const signupBlock = page.blocks.find(
    (block) => block._type === "signupBlock"
  );

  return (
    <Page
      title={page.seoTitle || page.title || page.heroTitle}
      description={page.seoDescription}
      pathname={pathname}
      {...otherProps}
    >
      <Hero>
        <Hero.Content>
          <Flex
            sx={{
              flexDirection: "column",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <Hero.Title>{page.heroTitle || page.title}</Hero.Title>
            {page.subtitle && <Hero.Subtitle>{page.subtitle}</Hero.Subtitle>}
          </Flex>
        </Hero.Content>
        {page.heroImage?.asset && (
          <Hero.Illustration>
            <Image fluid={page.heroImage.asset.fluid} />
          </Hero.Illustration>
        )}
      </Hero>
      {children}
      <Pagination
        itemCount={itemCount}
        pageSize={pageSize}
        pathname={pathname}
        current={currentPage}
        sx={{ mb: 7 }}
      />
      {signupBlock && <SignupBlock {...signupBlock} />}
    </Page>
  );
}
